import { is } from "date-fns/locale";
import moment from "moment";
const today = moment().startOf("day");

export const initialState = {
    login: {
        authenticated: false,
        keycloak: null,
        bearerToken: "",
        userProfile: {},
        userInfO: {},
        technicianInfo: {
            isAdmin: false,
            isLabourer: false,
        },
    },
    domain: {
        dateRange: {
            start: today.toDate(),
            end: moment(today).add(7, "day").toDate(),
        },
        timeRange: {
            start: 5 * 3600,
            end: 21 * 3600,
        },
        locale: {
            lang: "",
            messages: {},
        },
    },
    technicians: [],
    // Manage Labouorer filters Contracts and Skills
    contracts: [],
    allStatus: [],
    skills: [],
    // assignments contain a map of assignment & any overlaps returned from the
    // assignTask API call
    tasks: {
        fetching: false,
        tasks: [],
        workorderData: {
            activityQuestions: [],
            workorderData: {},
            //workorderInfo: {},
            confinedSpaceInfo: {},
        },
        purchaseOrderNumber: "",
        vendorManagerByOrder: {},
        assignmentInformation: "",
        requestTabValue: 0,
        isRequestToAddFollowup: false,
        isShowFollowups: true,
        isButtonDisabled: false,
        isBillingReasonMandatory: false,
        completionData: {},
        workorderDetails: {},
        counts: {
            totalCount: 0,
            dueTasksCount: 0,
            emergencyCount: 0,
            priorityCount: 0,
            unassignedTask: 0,
        },
        incompleteTaskResponse: {},
        reasoncodes: {},
        workOrderCancelledReasons: {},
        disbaleButton: false,
    },
    tasklist: {
        filters: {},
    },
    resources: [],
    assignments: {
        // assignments are stored as a map of days to assignments.  Where an array of assignment
        // is associated with the the date.
        // TODO: Blockouts are also in the Gantt.
        assignTaskRequest: null,
        assignments: [],
        overlaps: [],
    },
    alerts: [],
    errors: {},
    dashboard: {
        open: true,
        filter: {
            items: [],
            all: true,
        },
        zones: {
            items: [],
            all: true,
        },
        allStatuses: {
            items: [],
            all: true,
        },
        creationDate: {
            fromDate: "",
            toDate: "",
        },
        workOrderNumber: "",
    },
    gantt: {
        selectedLabourer: null,
        width: 500,
    },
    billing: {
        billingActivitiesRequest: null,
        activities: [],
        billingSKUInfoRequest: {},
        billingSKUInfoResponse: {},
        locateInfoRequest: {},
        locateInfoResponse: {},
        comments: [],
    },
    followUps: {
        followUpsRequest: null,
        followUpReasons: [],
        followUpsRequest: {},
        followUpsResponse: {},
        dueDate: "",
        isOpen: false,
        duplicateWO: [],
        noDuplicates: false,
    },
    additionalActions: {
        additionalActionRequest: null,
        additionalActionStatus: [],
        additionalActionRequest: {},
        additionalActionResponse: {},
    },
    reasons: {
        partialReasons: new Map(),
        completeCodeReasons: [],
    },
    requestNewDueDate: {
        requestNewDueDate: {},
        requestNewDueDateResponse: {},
    },
    workorder: {
        incomplete: {
            incompleteReason: true,
            incompleteSubReason: true,
            additionalComments: true,
            newDueDate: true,
        },
        complete: {
            completeReason: true,
            completeSubReason: true,
            additionalComments: true,
        },
    },
    isSelectedTechnicianEnabled: false,
    attachments: {
        filesToUpload: [],
        workOrderAttachments: [],
        fileUploadRes: [],
        fileUpdateRes: [],
        followupAttachments: [],
    },
    activityQuestions: {
        questions: {},
        isFetching: false,
        isError: false,
        error: {},
    },
};
